<template>
  <div class="score-bar-wrapper">
    <div
      v-for="index in 5"
      :key="index"
      class="lender-score-bar"
      :class="[index <= score ? 'filled' : 'outlined']"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'LenderScoreBar',
  props: {
    score: Number,
  },
}
</script>

<style lang="scss" scoped>
.score-bar-wrapper {
  width: 100%;
  max-width: 300px;

  display: grid;
  grid-template-columns: repeat(5, 25px);
  grid-template-rows: 10px;
  grid-column-gap: 10px;

  justify-content: center;

  @include lg {
    grid-column-gap: 2px;
  }
}

.lender-score-bar {
  width: 100%;
  height: 100%;

  background-color: white;
  border: 1px solid $primaryBlue;
  border-radius: 2px;

  &.filled { background-color: $primaryBlue; }
}
</style>
